import React from 'react';
export const MenuContext = React.createContext({});
//# sourceMappingURL=context.js.map